import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import {
  formatMoney,
  formatNumber,
  getDateTime,
} from "app/common/LocalFunction";
function DebtFeeDetailPopup({ initialValue, open, handleClose }) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="md"
      title="Danh sách công nợ"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: initialValue,
      }}
      hideSubmit
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TableComponent
                  className=""
                  showOrdinalNumbers
                  titleNodata={t("noData")}
                  data={values}
                  name="DebtFeePopup"
                  minWidth={"780px"}
                  showMoreButton
                  columns={[
                    {
                      field: "invoiceDate",
                      title: "Ngày đăng ký",
                      render: (item) => getDateTime(item?.invoiceDate),
                    },
                    {
                      field: "invoiceDate",
                      title: "Nội dung",
                      render: (item) => item?.invoiceItemName,
                    },
                    {
                      field: "currentFee",
                      title: "Đơn giá",
                      render: (item) => formatMoney(item?.currentFee),
                    },
                    {
                      field: "currentFee",
                      title: "Số lượng",
                      render: (item) => formatNumber(item?.quantity),
                    },
                    {
                      field: "currentFee",
                      title: "Giảm giá",
                      render: (item) => formatMoney(item?.discount),
                    },
                    {
                      field: "currentFee",
                      title: "Cần thu",
                      render: (item) =>
                        formatMoney(item?.subAmountActuallyPaid),
                    },
                    {
                      field: "subTotalBillPatientPaid",
                      title: "Đã thu",
                      render: (item) =>
                        formatMoney(item?.subTotalBillPatientPaid),
                    },
                    {
                      field: "subTotalBillPatientPaid",
                      title: "Còn nợ",
                      render: (item) =>
                        formatMoney(
                          item?.subAmountActuallyPaid -
                            (item?.subTotalBillPatientPaid || 0)
                        ),
                    },
                    {
                      title: t("Phân bổ"),
                      field: "staffRevenue",
                      // width: "550px",
                      render: (val) => (
                        <>
                          {val?.staffRevenues?.map((staffRevenue, index) => (
                            <div
                              key={index}
                              className="revenue-item"
                              style={{
                                display: "flex",
                                fontSize: 14,
                                marginBottom: 6,
                                padding: "4px 0",
                                borderBottom: "1px solid gray",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <span className="revenue-percent">
                                  {staffRevenue?.source?.name} -{" "}
                                </span>
                                <span className="position">
                                  {" "}
                                  {staffRevenue?.position?.name} -{" "}
                                </span>
                              </div>
                              <div>
                                <b className="staff-name">
                                  {staffRevenue?.staff?.staffName}
                                </b>
                                <i className="revenue-percent">
                                  {staffRevenue?.actualAmount && (
                                    <span className="label-primary-number">
                                      {formatMoney(staffRevenue?.actualAmount)}
                                      {"-"}
                                    </span>
                                  )}
                                  {formatNumber(staffRevenue?.percentRevenue) +
                                    "%"}
                                </i>
                              </div>
                            </div>
                          ))}
                        </>
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
}

export default memo(observer(DebtFeeDetailPopup));
